<template>
    <div :class="{ loader: true, fadeout: !isLoading }">
        <img src='../assets/img/logo-splash.png'></div>
    </template>

    <script>
        export default {name: "LoadingScreen", props: ["isLoading"]};
    </script>

    <style>
        .loader {
            background-color: #feebfa;
            bottom: 0;
            color: white;
            display: block;
            font-size: 32px;
            left: 0;
            overflow: hidden;
            padding-top: 43vh;
            position: fixed;
            right: 0;
            text-align: center;
            top: 0;
        }
        .loader img {
            width: 200px;
            height: 54px;
            padding: 0 0 1px;
            object-fit: contain;
        }

        .fadeout {
            animation: fadeout 2s forwards;
        }

        @keyframes fadeout {
            to {
                opacity: 0;
                visibility: hidden;
            }
        }
    </style>